import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function AuthUser() {
  const navigate = useNavigate();

  const getToken = () => {
    try {
      const tokenString = localStorage.getItem("medmyneAccess");
      if (!tokenString) return null;
      return JSON.parse(tokenString);
    } catch (e) {
      return localStorage.getItem("medmyneAccess") || null;
    }
  };

  const getUser = () => {
    try {
      const userString = localStorage.getItem("medmynePhone");
      if (!userString) return null;
      return JSON.parse(userString);
    } catch (e) {
      return null;
    }
  };

  const getUserRole = () => {
    try {
      const roleString = localStorage.getItem("medmyneRole");
      if (!roleString) return null;
      return JSON.parse(roleString);
    } catch (e) {
      return null;
    }
  };

  let userInfo = null;
  try {
    const userInfoString = localStorage.getItem("medmyne_user_info");
    userInfo = userInfoString ? JSON.parse(userInfoString) : null;
  } catch (e) {
    userInfo = null;
  }

  const [token, setToken] = useState(getToken());
  const [user, setUser] = useState(getUser());
  const [userRole, setUserRole] = useState(getUserRole());
  const [email, setEmail] = useState(getUser());
  // const [userInfo, setUserInfo] = useState([]);

  const saveToken = (email, access, role, userInfo, userIp) => {
    localStorage.setItem("medmyneAccess", JSON.stringify(access));
    localStorage.setItem("medmyneEmail", JSON.stringify(email));
    localStorage.setItem("medmyneRole", JSON.stringify(role));
    localStorage.setItem("medmyne_user_info", JSON.stringify(userInfo));
    localStorage.setItem("medmyne_user_ip", JSON.stringify(userIp));

    setEmail(email);
    setToken(token);
    // setUserInfo(userInfo);
    setUser(user);
    setUserRole(userRole);
    // setUserIp(userIp);
    navigate("/");
  };

  const logout = () => {
    const userId = userInfo?._id;
    let userIp = "";
    try {
      userIp = JSON.parse(localStorage.getItem("medmyne_user_ip")) || "";
    } catch (e) {
      console.error(e);
    }

    localStorage.clear();

    if (!userId) {
      toast.success("Successfully LogOut");
      navigate(`/`);
      window.location.reload();
      return;
    }

    fetch(`https://servercareseebd.careseebd.com/api/v1/user/delete-ip/${userId}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ ip: userIp }),
    })
      .then((response) => response.json())
      .then((data) => {
        toast.success("Successfully LogOut");
        navigate(`/`);
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error logging out from server:", error);
        toast.success("Successfully LogOut");
        navigate(`/`);
        window.location.reload();
      });
  };

  const headers = {
    "Content-type": "application/json",
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const http = axios.create({
    baseURL: "https://servercareseebd.careseebd.com/api/v1",
    headers,
  });

  return {
    setToken: saveToken,
    token,
    userRole,
    getToken,
    http,
    email,
    // getUserInfo,
    userInfo,
    logout,
    // userIp,
  };
}
